<template>
  <div class="message-page">
    <div class="message-page-inner">
      <div class="tabs">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="1" tab="系统通知">
            <system  />
          </a-tab-pane>
          <a-tab-pane key="2" tab="动态消息">
            <news  />
          </a-tab-pane>
          <a-tab-pane key="3" tab="站内消息">
            <site  />
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  computed,
  onMounted,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import News from "./news.vue";
import system from "./system.vue";
import site from "./site.vue";
import config from "../../until/configs";
import { getCookie } from "../../until/tools";

export default defineComponent({
  components: { system, News,site },
  setup() {
    let list = ref([]);
    const router = useRouter();
    const state = reactive({
      activeKey: "1",
      // msgType: 1,
      // currentPage: 1,
    });
    const route = useRoute();
    let userId = computed(() => {
      return route.query.userId;
    });
    let msgType = computed(() => {
      return route.query.msgType;
    });
    let currentPage = computed(() => {
      return route.query.currentPage;
    });

    onMounted(()=>{
      let sid = getCookie('z_sid');
      if(!sid) {
        router.push('/login');
        return false;
      }
      document.title = config.siteTitle;
    })

    return {
      list,
      userId,
      msgType,
      currentPage,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../scss/message.scss";
</style>